// extracted by mini-css-extract-plugin
module.exports = {"indicator":"indicator--37UvcLZy8X"};